<template>
    <div>
            <a-button class="top_btn" type="primary" @click="()=>{  visibleForm = true; titleForm='添加访客来源' }" v-has="'btn_add'"  > 添加
            </a-button>

        <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="false" rowKey="id" >
          <span slot="status" slot-scope="text, record">
         <a-switch   @click="onChange(record)"
                   :checked="text==1?true:false" :disabled="!$_has('btn_status')"/>
      </span>
            <span slot="action" slot-scope="text, record">
                <i v-if="$_hasAll(['btn_edit'])" style="color:#838383">暂无操作权限</i>
        <a @click="(record)=>{visibleForm = true; titleForm='修改访客来源'; editId=text.id ; }" v-has="'btn_add'"  >编辑</a>
      </span>
        </a-table>
        <NewForm :visible="visibleForm" :title="titleForm" :editId="editId"
                  @changVisible=" () => { this.visibleForm = false;this.editId='';  this.getList()}  "/>

    </div>

</template>

<script>
    import API from "./api";
    import NewForm from "./components/newForm"
    import {changStatus, removeById,orderList} from "../../../utils/utils"
    const columns = [
        // {
        //     title: "id",
        //     dataIndex: "id",
        //     ellipsis: true,
        //     key: "id"
        // },
        {
            title: "来源名称",
            dataIndex: "name",
            ellipsis: true,
            key: "name"
        },
        {
            title: "来源规则",
            dataIndex: "rule",
            ellipsis: true,
            key: "rule"
        },
        {
            title: "操作",
            key: "action",
            width: "100px",
            scopedSlots: {customRender: "action"}
        }
    ];
    export default {
        name: 'index',
        data() {
            return {
                visibleForm: false,
                titleForm: "",
                loading: true,
                editId: null,
                jurisdictionId: null,
                visibleJurisdiction: false,
                data: [],
                columns,
            }
        },
        created() {
            this.$store.state.adminleftnavnum = "/Set/SourceOfVisitors"; //设置左侧导航2-2 active
        },
        components: {NewForm},

        methods: {
            getList(page) {
                API.administrator.GET_AROLE(page||1).then(res => {
                    this.data = res.data.data
                    this.loading = false
                })
            },

            onChange(row) {
                let Json = {id: row.id, status: row.status == 0 ? 1 : 0}
                changStatus(API.administrator.CHANG_STATUS, [Json]).then(res => {
                    if (res == true) {
                        this.getList()
                    }
                })
            },
            confirm(id) {
                removeById(API.administrator.DELE,id).then(res => {
                    if (res == true) {
                        this.getList()
                    }
                })
            },
        },
        mounted() {
            this.getList()
        }

    }
</script>
